<template>
  <div class='half-year'>
    <head-top head-title='上个季度打卡统计' go-back='true'></head-top>
    <mt-cell :title="item.month+'月份'" is-link :to="'/PrevQuarterDetail/'+ item.year + '/' + item.month + '/' + $route.params.id" v-for="(item, index) in yearMonthData" :key="index"></mt-cell>
  </div>
</template>

<script>
import headTop from '../header/Header.vue'
import {getDakaData} from '../../api/jianli.js'

export default {
  data() {
    return {
      yearMonthData: {}
    }
  },
  components: {
    headTop
  },
  created() {
    this._getPrevQuarterData()
  },
  methods: {
    _getPrevQuarterData() {
      getDakaData('halfYear', this.$route.params.id).then(res => {
        this.yearMonthData = res.data
      })
    }
  }
}
</script>

<style lang='scss'>
  .half-year{
    padding-top: 40px;
    .mint-cell {
      &:last-child{
        background-size: 100% 0px;
        .mint-cell-wrapper {
        background-size: 100% 0px;
      }
      }
      .mint-cell-wrapper {
        background-size: 100% 1px;
        background-position: bottom left;
      }
    }
      .mint-cell-value.is-link {
        margin-right: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/content/HalfYear.vue